import { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import axios from 'axios';
import { Link } from 'react-router-dom';
import BlogSidebar from '../blog-common/BlogSidebar';
import API_BASE_URL from '../../../constants/api';

interface BlogPropd {
  style_1: boolean;
}

interface BlogItem {
  id: number;
  title: string;
  thumb: string;
  tag: string;
  category: string;
  date: string;
  author: string;
  read_time: string;
  comments_count: number;
  category_id:number
}


const itemsPerPage = 12;

const BlogArea = ({ style_1 }: BlogPropd) => {
  const [blogs, setBlogs] = useState<BlogItem[]>([]);
  const [currentItems, setCurrentItems] = useState<BlogItem[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<number | null>(null);

  const [itemOffset, setItemOffset] = useState(0);
const [searchQuery, setSearchQuery] = useState('');
const [selectedTag, setSelectedTag] = useState('');

  useEffect(() => {
    axios.get(`${API_BASE_URL}blogs`)
      .then((res) => {
         console.log(res)
       setBlogs(res.data);

      })
      .catch((err) => {
        console.error('Failed to fetch blogs:', err);
      });
  }, []);

const filteredBlogs = blogs.filter((blog) => {
  const matchTitle = blog.title.toLowerCase().includes(searchQuery.toLowerCase());
  const matchCategory = selectedCategory !== null ? blog.category_id === selectedCategory : true;
  const matchTag = selectedTag ? blog.tag === selectedTag : true;
  return matchTitle && matchCategory && matchTag;
});


useEffect(() => {
  const endOffset = itemOffset + itemsPerPage;
  setCurrentItems(filteredBlogs.slice(itemOffset, endOffset));
}, [itemOffset, blogs, searchQuery, selectedCategory, selectedTag]);

const pageCount = Math.ceil(filteredBlogs.length / itemsPerPage);


  const handlePageClick = (event: { selected: number }) => {
   const newOffset = (event.selected * itemsPerPage) % filteredBlogs.length;

    setItemOffset(newOffset);
  };



  

  return (
    <section className="blog-area section-py-120">
      <div className="container">
        <div className="row">
          <div className={`col-xl-9 col-lg-8 ${style_1 ? "order-0 order-lg-2" : ""}`}>
            <div className="row gutter-20">
              {currentItems.map((item) => (
                <div key={item.id} className="col-xl-4 col-md-6">
                  <div className="blog__post-item shine__animate-item">
                    <div className="blog__post-thumb">
                      <Link to={`/blog-details/${item.id}`} className="shine__animate-link"><img src={item.thumb} alt="img" /></Link>
                      <Link to="/blog" className="post-tag">{item.tag}</Link>
                    </div>
                    <div className="blog__post-content">
                      <div className="blog__post-meta">
                        <ul className="list-wrap">
                         <li>
                          <i className="flaticon-calendar"></i>
                          {new Date(item.date).toLocaleDateString('en-US', {
                            day: '2-digit',
                            month: 'long',
                            year: 'numeric'
                          })}
                        </li>

                          <li><i className="flaticon-user-1"></i>by <Link to={`/blog-details/${item.id}`}>{item.author}</Link></li>
                        </ul>
                      </div>
                      <h4 className="title"><Link to={`/blog-details/${item.id}`}>{item.title}</Link></h4>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <nav className="pagination__wrap mt-25">
              <ReactPaginate
                breakLabel="..."
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                pageCount={pageCount}
                renderOnZeroPageCount={null}
                className="list-wrap"
              />
            </nav>
          </div>
       <BlogSidebar
  style_1={style_1}
  setSearchQuery={setSearchQuery}
  setSelectedCategory={setSelectedCategory}
  setSelectedTag={setSelectedTag}
/>

        </div>
      </div>
    </section>
  );
};

export default BlogArea;
